import type { CSSProperties } from 'react';
import { RoundResult } from '../types';
import { humanizeNumber } from '../utils/format';

interface Props {
  rounds: RoundResult[];
}

export function RecapTimeline({ rounds }: Props) {
  if (!rounds.length) return null;

  return (
    <div className="recap-timeline" aria-live="polite">
      <div className="recap-line" aria-hidden />
      {rounds.map((round, index) => (
        <div
          key={round.id}
          className={`recap-row${round.correct ? '' : ' is-loss'}`}
          style={{ '--recap-delay': `${index * 60}ms` } as CSSProperties}
        >
          <span className="recap-node" aria-hidden />
          <div className="recap-content">
            <p className="recap-step-label">Guess {index + 1}</p>
            <div className="recap-pair">
              <div className={`recap-city-card${round.winnerId === round.leftCity.id ? ' is-winner' : ''}`}>
                <span className="recap-city-name">{round.leftCity.name}</span>
                <span className="recap-city-pop">{humanizeNumber(round.leftCity.population)}</span>
              </div>
              <div className="recap-diff" aria-label={`Difference of ${humanizeNumber(round.populationDiff)}`}>
                {humanizeNumber(round.populationDiff)}
              </div>
              <div className={`recap-city-card${round.winnerId === round.rightCity.id ? ' is-winner' : ''}`}>
                <span className="recap-city-name">{round.rightCity.name}</span>
                <span className="recap-city-pop">{humanizeNumber(round.rightCity.population)}</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
